<template>
    <div>
        <div class="info-box">
            <div class="info-title">
                <h3>课程信息</h3>
                <p></p>
            </div>
            <div class="info-main">
                <div class="input-box" >
                    <p>学年：</p>
                    <a-date-picker
                        :disabled="type=='look'"
                        class="input"
                        mode="year"
                        format='YYYY'
                        v-model="year" 
                        :open='yearShowOne' 
                        @openChange="openChangeOne"
                        @panelChange="panelChangeOne">
                        <a-input  v-model="info.schoolYear" />
                    </a-date-picker>
                </div>
                <div class="input-box">
                    <p>学期：</p>
                    <a-select class="input" allowClear v-model="info.semester" :disabled="type=='look'">
                        <!-- For years before 2025, keep all options -->
                        <template v-if="year < '2025'">
                            <a-select-option  :value="year+'A'">秋季学期</a-select-option>
                            <a-select-option  :value="year+'B'">冬季学期</a-select-option>
                            <a-select-option  :value="(year-0+1)+'C'">春季学期</a-select-option>
                            <a-select-option  :value="(year-0+1)+'D'">夏季学期</a-select-option>
                        </template>
                        <!-- For 2025 and later, only show two semesters -->
                        <template v-else>
                            <a-select-option :value="year+'A'">秋季学期</a-select-option>
                            <a-select-option :value="(year-0+1)+'C'">春季学期</a-select-option>
                        </template>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>课程名：</p>
                    <a-select 
                        :disabled="type=='look'"
                        class="input" 
                        allowClear 
                        v-model="info.courseName" 
                        :filter-option="filterOption" 
                        show-search
                         @change="kcChange">
                        <a-select-option v-for="(item,index) in kcArr" :key="index" :value="item.courseName">{{item.courseName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>课程号：</p>
                    <a-input class="input" v-model="info.courseId" disabled />
                </div>
                <div class="input-box">
                    <p>学分：</p>
                    <a-input class="input" v-model="info.credit"  :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>教学班：</p>
                    <a-input class="input" v-model="info.teachClass"  :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>教师姓名：</p>
                    <a-select 
                        :disabled="type=='look'"
                        class="input" 
                        allowClear
                        show-search
                        :filter-option="filterOption"
                        v-model="info.teacherName"
                        @change="teacherChange"
                        option-label-prop="label"
                        >
                        <a-select-option v-for="(item,index) in jsArr" :key="index" :value="item.teacherName" :label="item.teacherName">{{item.teacherId}}-{{item.teacherName}}</a-select-option>
                    </a-select>
                </div>
                <div class="input-box">
                    <p>教师编号：</p>
                    <a-input class="input" v-model="info.teacherId" disabled />
                </div>
                <div class="input-box">
                    <p>班号：</p>
                    <a-input class="input" v-model="info.classId"  :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>上课时间：</p>
                    <a-input class="input" v-model="info.classTime" :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>上课地点：</p>
                    <a-input class="input" v-model="info.classRoom"  :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>容量：</p>
                    <a-input class="input" v-model="info.studentCapacity" :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>选课人数：</p>
                    <a-input class="input" v-model="info.studentNumber"  :disabled="type=='look'"/>
                </div>
                <div class="input-box">
                    <p>答疑时间：</p>
                    <a-input :class="type == 'answer' ? 'answer-input' : 'input'" v-model="info.answerTime" :disabled="(type!='answer' && info.teacherId==$store.state.user.userId) || type=='look'" />
                </div>
                <div class="input-box">
                    <p>答疑地点：</p>
                    <a-input :class="type == 'answer' ? 'answer-input' : 'input'" v-model="info.answerRoom" :disabled="(type!='answer' && info.teacherId==$store.state.user.userId) || type=='look'" />
                </div>
                <div class="input-box">
                    <p>机房：</p>
                    <a-input class="input" v-model="info.computerRoom"  :disabled="type=='look'"/>
                </div>
                <div class="input-box input-box-center">
                    <p>备注：</p>
                    <a-textarea class="input" :rows="2"  v-model="info.remark" :disabled="type=='look'"/>
                </div>
            </div>
        </div>
        <div class="btn-box" v-if="intoType != 'into'">
            <!-- <a-button type="primary" v-if="type=='look'&&(permissions.indexOf('undergraduate:culture:course:edit')>-1||info.teacherId==$store.state.user.userId)" @click="type='update'">编辑</a-button> -->
            <a-button type="primary" v-if="(type=='look' || type=='answer')&&(permissions.indexOf('undergraduate:culture:course:edit')>-1||info.teacherId==$store.state.user.userId)" @click="sub">提交</a-button>
            <a-popconfirm
                title="确定删除？"
                ok-text="确定"
                cancel-text="取消"
                @confirm="remove"
                v-if="type=='look'&&permissions.indexOf('undergraduate:culture:course:delete')>-1">
                <a class="action-btn">删除</a>
            </a-popconfirm>
            <a-button @click="$router.go(-1)">取消</a-button>
        </div>
    </div>
</template>
<script>
    import { add,update,info,del } from '@/baseAPI/undergraduate/culture/course'
    import { getTeacher } from '@/baseAPI/facultyTeacher'
    import { list } from '@/baseAPI/undergraduate/culture/courseMould'
    import { getSchoolYear } from '@/baseAPI/util'
    
    export default {
        name: 'teacher',
        components: {
        },
        data () {
            return {
                type:'',
                info:{
                    schoolYear:null,
                    semester:null,
                    courseName:null,
                    credit:null,
                    teachClass:null,
                    courseId:null,
                    teacherName:null,
                    teacherId:null,
                    classTime:null,
                    classRoom:null,
                    studentCapacity:null,
                    studentNumber:null,
                    answerTime:null,
                    answerRoom:null,
                    classId:null,
                    campus:null,
                    remark:null,
                },
                year:'',
                yearShowOne:false,
                jsArr:[],
                kcArr:[],
                permissions:[],
            }
        },
        props:{
            intoType:null,intoCourseId:null
        },
        mounted () {
            this.permissions=this.$store.state.user.permissions==null?[]:this.$store.state.user.permissions;
            this.year=getSchoolYear()+''
            this.info.schoolYear=getSchoolYear()+'-'+(getSchoolYear()+1)
            list().then(res=>{
                this.kcArr=res.data;
            })
            getTeacher().then(res=>{
                this.jsArr=res.data;
            })

            this.type=this.$route.query.type;
            
            let that = this;
            if(this.intoType){
                that.into()
            }else if(this.type!='add'){
                setTimeout(()=>{
                    info(this.$route.query.id).then(res=>{
                        this.info=res.data;
                    })
                },1000)
            }

        },
        methods:{
            into(){
                this.year=this.getTimeStr(new Date(),'yyyy')
                this.info.schoolYear=this.year+'-'+(this.year-0+1);
                list().then(res=>{
                    this.kcArr=res.data;
                })
                getTeacher().then(res=>{
                    this.jsArr=res.data;
                })
                this.type='look';
                setTimeout(()=>{
                    info(this.intoCourseId).then(res=>{
                        this.info=res.data;
                    })
                },1000)
                                     
            },
            filterOption(input, option) {
                return (
                    option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            },
            sub(){
                var isSub=true;
                var arr=['schoolYear','semester','courseName','credit','courseId','teacherName','teacherId','classTime','classId','classRoom','studentCapacity','studentNumber','answerTime','answerRoom']
                console.log(this.info)
                for(let i=0;i<arr.length;i++){
                    if(this.info[arr[i]]==null||this.info[arr[i]]===''){
                        isSub=false;
                        break;
                    }
                }
                if(isSub){
                    if(this.type=='add'){
                        add(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'新增课程成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }else{
                        update(this.info).then(res=>{
                            if(res.data.success){
                                this.$notification['success']({
                                    message: '成功',
                                    description:'修改课程成功',
                                });
                                this.$router.go(-1)
                            }else{
                                this.$notification['error']({
                                    message: '失败',
                                    description:res.data.errorMessage,
                                });
                            }
                        })
                    }
                }else{
                    this.$notification['warning']({
                        message: '警告',
                        description:'请填写完整！',
                    });
                }
            },
            teacherChange(value){
                for(let i=0;i<this.jsArr.length;i++){
                    if(this.jsArr[i].teacherName==value){
                        this.info.teacherId=this.jsArr[i].teacherId
                    }
                }
            },
            kcChange(value){
                for(let i=0;i<this.kcArr.length;i++){
                    if(this.kcArr[i].courseName==value){
                        this.info.courseId=this.kcArr[i].courseCode
                    }
                }
            },
            // 弹出日历和关闭日历的回调
            openChangeOne(status) {
                    if (status){
                        this.yearShowOne =  true
                    }
                },
            // 得到年份选择器的值
            panelChangeOne(value) {
                this.year=this.getTimeStr(value._d,'yyyy')
                this.info.schoolYear=this.year+'-'+(this.year-0+1);
                this.info.semester='';
                this.yearShowOne = false;
            },
            remove(){
                del(this.info.id).then(res=>{
                    if(res.data.success){
                        this.$notification['success']({
                            message: '成功',
                            description:'删除课程表成功',
                        });
                        this.$router.go(-1)
                    }else{
                        this.$notification['error']({
                            message: '失败',
                            description:res.data.errorMessage,
                        });
                    }
                })
            },

        }
    }
</script>
<style scoped>
    .info-box{
        margin-bottom: 2rem;
    }
    .info-title{
        position: relative;
        line-height: 3rem;
    }
    .info-title h3{
        font-size: 1.2rem;
        font-weight: bold;
        letter-spacing: 2px;
        padding-left: 10px;
        color: #245086;
    }
    .info-title p{
        position: absolute;
        left: 0;
        bottom: 0;
        width: 50%;
        height: 3px;
        background-image: linear-gradient(to right, #245086 , rgba(36,80,134,0));
    }
    .info-title .ant-btn{
        float: right;
        margin-top: calc(1.5rem - 16px);
        margin-right: 2rem;
    }
    .info-main{
        display: flex;
        flex-wrap: wrap;
        margin-top: 1.5rem;
    }
    .info-main .input-box{
        width: 33%;
        display: flex;
        line-height: 32px;
        margin-bottom: 1.5rem;
        position: relative;
    }
    .info-main .input-box-center{
        width: 99%;
    }
    .info-main .input-box p{
        width: 10rem;
        text-align: right;
    }
    .info-main .input-box .input{
        width: calc(100% - 10rem);
    }

    .info-main .input-box .answer-input{
        width: calc(100% - 10rem);
        border-color:red;
    }

    .info-main .input-box .tips{
        width: calc(100% - 11rem);
        position: absolute;
        right: 0;
        top: 100%;
        font-size: 13px;
        line-height: 20px;
        color: #1890ff;
    }
    .ant-table-wrapper{
        margin-top: 2rem;
    }
    .ant-table-wrapper >>> .ant-empty-normal{
        display: none;
    }
    .text-box{
        display: flex;
        margin-bottom: 0.5rem;
    }
    .text-box p{
        font-size: 1rem;
        line-height: 2rem;
    }
    .text-box .title{
        width: 5rem;
        text-align: right;
    }
    .text-box .text{
        border: 1px solid #ccc;
        padding: 0 10px;
        border-radius: 5px;
    }
    .action-btn{
        color: #40a9ff;
        display: inline-block;
    }
    .ant-table-wrapper >>> .ant-table-thead > tr > th,
    .ant-table-wrapper >>> .ant-table-tbody > tr > td{
        padding: 10px;
    }
    .ant-table-wrapper .input-box{
        width: 100%;
    }
    .btn-box{
        text-align: center;
    }
    .btn-box .ant-btn{
        margin: 0 1rem;
    }
    .ant-input[disabled],.ant-select-disabled,.ant-input-number-disabled{
        color: rgba(0, 0, 0, 0.65);
        background-color: transparent;
    }
    .ant-select-disabled >>> .ant-select-selection{
        background-color: transparent;
    }
    .action-btn{
        background-color: #1890ff;
        color: #fff;
        line-height: 32px;
        padding: 0 15px;
        height: 32px;
        border-radius: 4px;
    }
</style>
